import { CorrelationStorage } from "./sessionStore";

// Envuelve un storage para que nunca lance. Si el storage del navegador no está
// disponible (modo incógnito, storage bloqueado, algunos webviews), los accesos
// degradan a una copia en memoria en vez de cortar el logging o las llamadas.
export const safeStorage = (storage: CorrelationStorage): CorrelationStorage => {
  const fallback = new Map<string, string>();
  // Keys cuyo último escritura o borrado no llegó al storage. Para esas se lee
  // de memoria, así no se devuelve un valor viejo que quedó en el storage.
  const memoryOnly = new Set<string>();

  const fromMemory = (key: string) =>
    fallback.has(key) ? fallback.get(key)! : null;

  return {
    get: (key) => {
      if (memoryOnly.has(key)) return fromMemory(key);
      try {
        const value = storage.get(key);
        if (value !== null) return value;
      } catch {
        // storage no disponible, se usa la copia en memoria
      }
      return fromMemory(key);
    },
    set: (key, value) => {
      fallback.set(key, value);
      try {
        storage.set(key, value);
        memoryOnly.delete(key);
      } catch {
        memoryOnly.add(key);
      }
    },
    remove: (key) => {
      fallback.delete(key);
      try {
        storage.remove(key);
        memoryOnly.delete(key);
      } catch {
        memoryOnly.add(key);
      }
    },
  };
};
